import type { Ref } from 'react'

import { forwardRef } from 'react'

import Icon from '@space-lib/components/icon'
import clsx from 'clsx'
import styled from 'styled-components'

import type { ButtonProps } from './types'
import { VariationTypes } from './types'
import '@hotmart/cosmos/dist/button/button.css'
import '@hotmart/cosmos/dist/button/variations/custom.css'
import '@hotmart/cosmos/dist/button/variations/block.css'
import '@hotmart/cosmos/dist/button/variations/small.css'
import '@hotmart/cosmos/dist/button/variations/large.css'

const MembershipButton = styled.button<ButtonProps>`
  line-height: 1rem;
`
const IconButton = styled(Icon)`
  margin-right: var(--spacer-2);
`

const CustomButton = (
  {
    children,
    className,
    size,
    icon,
    variation = VariationTypes.PRIMARY,
    type = 'button',
    active = false,
    disabled = false,
    loading = false,
    ...rest
  }: ButtonProps,
  ref: Ref<HTMLButtonElement>
) => {
  const buttonClass = clsx(
    'hot-button',
    '_rounded-md',
    {
      [`hot-button--${variation}`]: variation !== 'default',
      [`hot-button--${size}`]: size,
      'hot-button--active': active,
      'hot-button--loading': loading,
      'hot-button--disabled': disabled
    },
    className
  )

  return (
    <MembershipButton
      data-test='membership-button'
      disabled={disabled}
      variation={variation}
      ref={ref}
      className={buttonClass}
      type={type}
      {...rest}>
      {icon && <IconButton icon={icon} data-test='button-icon' />}
      {children}
    </MembershipButton>
  )
}

export default forwardRef(CustomButton)
